import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ActivatedRoute, Router } from '@angular/router';
import { Asociado, AsociadosService, Historico, HistoricoService, ResponseAsociados } from '../../../api';
import { BodyRequest, FunctionsAvailable, ItemType } from '../formulario/request.model';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertService } from '../alert/alert.service';
import { SpinnerComponent } from '../spinner/spinner.component';
import { ModeType } from '../core/core.component';
import { Field } from '../formulario/field.model';
import { FORM_BUTTONS } from '../formulario/form-buttons.config';
import { FormButtonType } from '../formulario/formButtonType.enum';
import { FormularioService } from '../../services/formulario.service';
import { NavegacionService } from '../../services/navegacion.service';
import { MigasService } from '../../services/migas.service';
import { mensajeErrorAccion, mensajeErrorCarga } from '../../core/http-errors';
import { ErrorFichaComponent } from '../error-ficha/error-ficha.component';
import { FormularioComponent } from '../formulario/formulario.component';
import { HistoricoEditarComponent } from '../historico-editar/historico-editar.component';
import { ETIQUETA_ESTADO } from '../historico/historico.component';
import { HistoricoApiService, RelacionHistorico } from '../../services/historico-api.service';
import { PermisosService } from '../../services/permisos.service';
import { DialogAlertService } from '../dialog-alert/dialog-alert.service';
import { AlertButtonType } from '../dialog-alert/AlertButtonType.enum';

@Component({
  selector: 'app-historico-asociado',
  standalone: true,
  imports: [CommonModule, RouterLink, SpinnerComponent, FormularioComponent, ErrorFichaComponent, HistoricoEditarComponent],
  templateUrl: './historico-asociado.component.html',
  styleUrl: './historico-asociado.component.scss'
})
export class HistoricoAsociadoComponent {
  ItemType = ItemType;

  preUrl: string = '';

  /** Relaciones del asociado (GET /historico?asociado=): vigentes por defecto; con «mostrar todo», también bajas y desactivados. */
  relaciones: RelacionHistorico[] = [];
  totalRelaciones = 0;
  mostrarTodo = false;
  cargandoRelaciones = false;
  errorRelaciones = '';
  editando: RelacionHistorico | null = null;
  readonly ETIQUETA = ETIQUETA_ESTADO;
  asociado!: Asociado;

  loading: boolean = true;
  error = '';



  type: ItemType = ItemType.HISTORICO;
  titleForm = 'Cambiar histórico';
  mode: ModeType = 'list';
  buttons = [
    FORM_BUTTONS[FormButtonType.Borrar],
    FORM_BUTTONS[FormButtonType.Cancelar],
  ]
  itemParse: Historico = {
    idAsociacion: 0,
    idAsociado: 0,
    idCargo: 0,
    ejercicio: 0
  }
  
  functionSelected!: FunctionsAvailable;
  public fields: Field[] = [];
  title: string = '';

  constructor(
    private route: ActivatedRoute,
    private asociadosService: AsociadosService,
    private historicoService: HistoricoService,
    private historicoApi: HistoricoApiService,
    private dialogo: DialogAlertService,
    protected permisos: PermisosService,
    private formularioService: FormularioService,
    private alertService: AlertService,
    private router: Router,
    private nav: NavegacionService,
    private migas: MigasService
  ) {}

  get puedeEscribir(): boolean { return this.permisos.tieneGlobal('historico:escribir'); }

  ngOnInit() {
    // Desde la consulta del Histórico se llega con ?editar=asociación_cargo_ejercicio: la fila puede ser de un ejercicio anterior,
    // así que se listan también los ejercicios anteriores y las bajas.
    if (this.route.snapshot.queryParamMap.get('editar')) this.mostrarTodo = true;
    let id = Number(this.route.snapshot.paramMap.get('id'));
    this.preUrl = this.route.snapshot.url[0].path;
    this.loadData(id!);
  }

  loadData(id: number) {
    this.loading = true;
    this.error = '';
    if (!Boolean(id)) {
      id = this.asociado?.id;
    }
    if (Boolean(id) && id !== -1) {
      this.asociadosService.asociadosGetById(id!).subscribe({
        next: (asociado: ResponseAsociados) => {
          const encontrado = asociado.status?.status === 200 ? asociado.asociados?.[0] : undefined;
          if (!encontrado) {
            this.fallar('El asociado no existe.');
            return;
          }
          this.asociado = encontrado;
          this.migas.etiqueta('asociado:' + id, [encontrado.nombre, encontrado.apellidos].filter(Boolean).join(' '));
          this.loading = false;
          this.cargarRelaciones(true);
        },
        error: (err: HttpErrorResponse) => this.fallar(mensajeErrorCarga(err, 'el asociado'))
      });
    } else {
      this.fallar('El asociado no existe.');
    }
  }

  /** Pide las relaciones del asociado a la API paginada (hasta 100: un asociado tiene decenas como mucho). */
  cargarRelaciones(abrirEdicionDeLaUrl = false) {
    this.cargandoRelaciones = true;
    this.errorRelaciones = '';
    this.historicoApi.consultar({ asociado: this.asociado.id, estado: this.mostrarTodo ? 'todos' : 'vigente', page: 1, pageSize: 100, dir: 'desc' }).subscribe({
      next: res => {
        this.relaciones = res.historico;
        this.totalRelaciones = res.paginacion.total;
        this.cargandoRelaciones = false;
        if (abrirEdicionDeLaUrl) this.abrirEdicionDeLaUrl();
      },
      error: (err: HttpErrorResponse) => { this.cargandoRelaciones = false; this.errorRelaciones = mensajeErrorCarga(err, 'el histórico'); }
    });
  }

  alternarMostrarTodo() {
    this.mostrarTodo = !this.mostrarTodo;
    this.cargarRelaciones();
  }

  /** ?editar=asociacion_cargo_ejercicio (desde la consulta del Histórico) abre directamente la edición de ese registro. */
  private abrirEdicionDeLaUrl() {
    const clave = this.route.snapshot.queryParamMap.get('editar');
    if (!clave || !this.puedeEscribir) return;
    const [asociacion, cargo, ejercicio] = clave.split('_').map(Number);
    this.editando = this.relaciones.find(r => r.idAsociacion === asociacion && r.idCargo === cargo && r.idEjercicio === ejercicio) ?? null;
  }

  editar(relacion: RelacionHistorico) { this.editando = relacion; }
  cerrarEdicion() { this.editando = null; }
  tras_guardar() { this.editando = null; this.cargarRelaciones(); }

  /** Baja lógica (nunca borrado físico), con confirmación: antes se ejecutaba al primer clic. */
  darDeBaja(relacion: RelacionHistorico) {
    this.dialogo.openDialogAlert({
      title: 'Dar de baja el registro',
      content: `Vas a dar de baja «${relacion.cargo}» de ${relacion.nombre} ${relacion.apellidos} en ${relacion.nombreAsociacion} (ejercicio ${relacion.anyoEjercicio}).\n\nLa baja es lógica: el registro se conserva como baja. ¿Quieres continuar?`,
      buttonsAlert: [AlertButtonType.Cancelar, AlertButtonType.Aceptar]
    }).afterClosed().subscribe(respuesta => {
      if (respuesta === AlertButtonType.Aceptar) this.deleteItem({ idAsociacion: relacion.idAsociacion, idCargo: relacion.idCargo, idEjercicio: relacion.idEjercicio });
    });
  }

  private fallar(mensaje: string) {
    this.error = mensaje;
    this.loading = false;
    this.alertService.danger(mensaje, 5000);
  }

  /** Vuelve a la página previa de Censo (con sus filtros) o, si no la hay, a la ficha del asociado. */
  volver() {
    const id = Number(this.route.snapshot.paramMap.get('id')) || this.asociado?.id;
    this.nav.volver(id ? '/asociados/' + id : '/asociados');
  }

  volverAlListado() {
    this.nav.volverAlListado('/asociados');
  }

  deleteItem(event: BodyRequest | any) {
    this.historicoService.historicoDelete(event.idAsociacion, this.asociado.id, event.idCargo, event.idEjercicio).subscribe({
      next: (res: any) => {
        
        if (res.status.status === 200){
          this.alertService.success('Histórico actualizado con éxito!', 5000);
          this.cargarRelaciones();
        }else {
          this.alertService.danger('Hubo un problema en el borrado: ' + (res.status?.message ?? ''), 5000);
        }
      },
      error: (err: HttpErrorResponse) => this.alertService.danger(mensajeErrorAccion(err, 'No se ha podido dar de baja el registro.'), 5000)
    })
  }

  public loadFormConfig(functionType: string) {
    this.itemParse.idAsociado = this.asociado.id;
    let {fields, extraFields, buttons, titleForm, mode, type, functionSelected} = this.formularioService.loadFormConfig(functionType, this.buttons, this.itemParse, this.mode, this.type, this.titleForm);
    this.fields = [...fields, ...extraFields];
    this.buttons = buttons;
    this.titleForm = titleForm;
    this.functionSelected = FunctionsAvailable[functionSelected as keyof typeof FunctionsAvailable];
    this.mode = mode;
    this.type = type;
    this.loading = false;
  }

}
